import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-student-speak',
  templateUrl: './student-speak.component.html',
  styleUrls: ['./student-speak.component.scss']
})
export class StudentSpeakComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
